import { connect } from 'react-redux';
import { selectors } from 'app-webtech-core';
import { TRENDING, VOD, WATCH } from 'app-source/routes/types';
import * as chatSelectors from 'app-modules/chat/selectors';
import { redirect } from 'redux-first-router';
import { FooterMenuComponent } from '../components/FooterMenu';
import { sectionSelect } from '../utils/sectionSelect';
import { checkMobileOperatingSystem } from '../utils/checkMobileOperatingSystem';

const mapStateToProps = (state) => {
  const { isFullscreen } = selectors.player.properties(state);
  const { isIos, isAndroid } = checkMobileOperatingSystem();
  const isMobile = isIos || isAndroid;
  return {
    page: state.page,
    isFullscreen,
    isMobile,
    isChatBarShown: chatSelectors.isEnabled(state) && chatSelectors.isVisible(state),
    locationType: selectors.location.properties(state).type,
  };
};

const mapDispatchToProps = (dispatch) => ({
  redirectToTrending: () => dispatch(redirect({ type: TRENDING })),
  redirectToVod: () => sectionSelect(dispatch, VOD),
  redirectToWatch: () => sectionSelect(dispatch, WATCH),
});

const mergeProps = ({ locationType, ...stateProps }, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  redirectToWatch: () => {
    if (locationType !== 'PAGE_WATCH_CHANNEL') {
      dispatchProps.redirectToWatch();
    }
  },
});

export const FooterMenu = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(FooterMenuComponent);
